import * as React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import {
  InstructionDocumentType,
  GetCatalogProductViewQuery,
} from '@notino/shared/definitions/types';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { Description } from '../styled';

import messages from './messages';
import { InstructionsWrapper, PdfWrapper } from './styled';

interface IInstructionsProps {
  instructions: string;
  instructionDocument: GetCatalogProductViewQuery['productDetailByCatalogMasterId']['variants'][number]['documentation']['document'];
}

const messageMap: Record<InstructionDocumentType, MessageDescriptor> = {
  InstructionsForUse: messages.instructionsForUse,
  PackagingInformation: messages.packagingInformation,
};

export const Instructions: React.FC<IInstructionsProps> = ({
  instructions,
  instructionDocument,
}) => {
  const newPdDesignEnabled = useNewPdDesignEnabled();
  const instructionMessage = messageMap[instructionDocument?.type];

  return (
    <InstructionsWrapper newPdDesignEnabled={newPdDesignEnabled}>
      {instructions && (
        <Description
          newDesign={newPdDesignEnabled}
          style={{ marginTop: '0' }}
          dangerouslySetInnerHTML={{
            __html: instructions,
          }}
        />
      )}

      {instructionMessage && (
        <PdfWrapper>
          <Description
            data-testid="new-pdf-instructions"
            newDesign={newPdDesignEnabled}
            style={{ marginTop: '0' }}
          >
            <p>
              <FormattedMessage
                {...instructionMessage}
                values={{
                  a: (parts) => (
                    <a
                      rel="nofollow noreferrer"
                      target="_blank"
                      href={instructionDocument.url}
                    >
                      {parts}
                    </a>
                  ),
                }}
              />
            </p>
          </Description>
        </PdfWrapper>
      )}
    </InstructionsWrapper>
  );
};
